import { Component, Input } from '@angular/core';

@Component({
  selector: 'thermometer-widget',
  templateUrl: './thermometer-widget.component.html',
  styleUrls: ['./thermometer-widget.component.scss']
})
export class ThermometerWidgetComponent {

  @Input() value?: number;
  @Input() setToValue?: number;
  @Input() label?: string;
  @Input() disabled?: boolean = false;
  @Input() expanded?: boolean = false;
  @Input() unavailable?: boolean = false;

  public get setToTemp(): string {
    if (this.unavailable) return '--';
    // Always show the setpoint temperature if available
    if (this.setToValue !== undefined && this.setToValue !== null) {
      return `${this.setToValue}`;
    }
    return '–––';
  }
  
  public getValue(): string {
    if (this.unavailable) return '--';
    return this.value ? `${this.value}` : '–';
  }
}
